"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBrowserStoreLocale = exports.URLParse = exports.createNewURL = exports.createNewURLPath = exports.getCleanURLPath = exports.createNewBrowserPath = exports.getCleanBrowserPath = exports.getCurrentBrowserPath = exports.getBrowserCurrentCountryCode = exports.getBrowserStoreLocale = exports.addStoreLocaleByCookie = exports.getStoreLocaleByCookie = exports.getGeoZoneDestinationCode = exports.cleanUpURLSlash = exports.getIsBrowserAvailable = void 0;
const iso2GeoZones_1 = __importDefault(require("../constants/iso2GeoZones"));
const canonicalUrlMappings_1 = __importDefault(require("../constants/canonicalUrlMappings"));
const helpers_1 = require("./helpers");
const cookies_1 = require("../cookies");
const constants_1 = require("../constants");
const { SITE_URL } = process.env;
const getIsBrowserAvailable = () => {
    const isBrowserAvailable = typeof window !== 'undefined';
    return isBrowserAvailable;
};
exports.getIsBrowserAvailable = getIsBrowserAvailable;
const cleanUpURLSlash = (value) => {
    return (value
        // Remove repeating `//en-ca/path/////name` => /en-ca/path
        .replace(/[/]{2,}/g, '/')
        // Remove Trailing Slash => `/en-ca/` => `/en-ca`
        .replace(/\/$/, '') || '/' // We need to return / for home page
    );
};
exports.cleanUpURLSlash = cleanUpURLSlash;
const getGeoZoneDestinationCode = (country) => {
    return iso2GeoZones_1.default[country] || 'US';
};
exports.getGeoZoneDestinationCode = getGeoZoneDestinationCode;
const getFullURL = (url) => {
    const result = new URL(url || '', SITE_URL || constants_1.PRODUCTION_BASE_URL);
    return result;
};
const shouldIgnoreURL = (url) => {
    const { href, hostname, protocol } = url;
    // Skip Rules
    const envResult = new URL('', SITE_URL || constants_1.PRODUCTION_BASE_URL);
    const { hostname: envHostname } = envResult;
    const isEaselAPi = href.search(/easel_api/) > -1;
    const isDifferentDomain = hostname !== envHostname;
    const isMailProtocol = protocol === 'mailto:';
    if (isDifferentDomain || isMailProtocol || isEaselAPi) {
        return true;
    }
    return false;
};
const getStoreLocaleByCookie = () => {
    const userPreferencesCookie = (0, cookies_1.getCookie)({
        name: 'saatchi_user_preferences',
    }) || '{}';
    const userPreferencesValue = (0, cookies_1.decodeCookie)(userPreferencesCookie); // { country: 'CA', ... }
    const userPreferences = JSON.parse(userPreferencesValue);
    const { storeLocale } = userPreferences;
    return storeLocale;
};
exports.getStoreLocaleByCookie = getStoreLocaleByCookie;
const addStoreLocaleByCookie = (url) => {
    const result = getFullURL(url);
    const { hash, pathname, search } = result;
    if (shouldIgnoreURL(result)) {
        return url;
    }
    const storeLocale = (0, exports.getStoreLocaleByCookie)();
    const updatedPath = (0, exports.createNewURLPath)(pathname, storeLocale);
    return `${updatedPath}${hash || ''}${search || ''}`;
};
exports.addStoreLocaleByCookie = addStoreLocaleByCookie;
const getBrowserStoreLocale = () => {
    const isBrowserAvailable = (0, exports.getIsBrowserAvailable)();
    if (!isBrowserAvailable) {
        return 'en-us';
    }
    const path = window.location.pathname || '';
    const pathStoreLocale = (0, helpers_1.getStoreLocaleFromURL)(path);
    if (!pathStoreLocale) {
        return 'en-us';
    }
    return pathStoreLocale.replace('/', '');
};
exports.getBrowserStoreLocale = getBrowserStoreLocale;
const getBrowserCurrentCountryCode = () => {
    const browserStoreLocale = (0, exports.getBrowserStoreLocale)();
    const countryCode = (0, helpers_1.getValidCountryCodeFromStoreLocale)(browserStoreLocale);
    return countryCode;
};
exports.getBrowserCurrentCountryCode = getBrowserCurrentCountryCode;
const getCurrentBrowserPath = () => {
    const path = window.location.pathname || '';
    const query = window.location.search || '';
    const hash = window.location.hash || '';
    // /checkout/shipping#table?price=usd
    return path + hash + query;
};
exports.getCurrentBrowserPath = getCurrentBrowserPath;
const getCleanBrowserPath = () => {
    const path = window.location.pathname || '';
    const query = window.location.search || '';
    const hash = window.location.hash || '';
    // /en-ca/checkout/shipping => /checkout/shipping
    const cleanPath = (0, helpers_1.removeStoreLocaleFromURL)(path);
    return cleanPath + hash + query;
};
exports.getCleanBrowserPath = getCleanBrowserPath;
const createNewBrowserPath = (storeLocale = '') => {
    const path = (0, exports.getCleanBrowserPath)();
    if (storeLocale === 'en-us') {
        return (0, exports.cleanUpURLSlash)(path);
    }
    return (0, exports.cleanUpURLSlash)(`/${storeLocale}${path}`);
};
exports.createNewBrowserPath = createNewBrowserPath;
const getCleanURLPath = (url) => {
    // /en-ca/checkout/shipping => /checkout/shipping
    return url.replace(/^\/en-[A-Za-z]{2}/, '');
};
exports.getCleanURLPath = getCleanURLPath;
const createNewURLPath = (url, storeLocale = '') => {
    const path = (0, exports.getCleanURLPath)(url);
    if (storeLocale === 'en-us') {
        return (0, exports.cleanUpURLSlash)(path);
    }
    return (0, exports.cleanUpURLSlash)(`/${storeLocale}${path}`);
};
exports.createNewURLPath = createNewURLPath;
const createNewURL = (url, storeLocale = '') => {
    const result = getFullURL(url);
    const { hash, origin, pathname, search } = result;
    if (shouldIgnoreURL(result)) {
        return url;
    }
    const updatedPath = (0, exports.createNewURLPath)(pathname, storeLocale);
    const newURL = `${origin}${updatedPath}${hash || ''}${search || ''}`;
    // Check if any key from canonical URL mappings matches part of newURL
    for (const [sourceUrl, canonicalUrl] of Object.entries(canonicalUrlMappings_1.default)) {
        if (newURL.includes(sourceUrl)) {
            return newURL.replace(sourceUrl, canonicalUrl);
        }
    }
    return newURL;
};
exports.createNewURL = createNewURL;
// We only want to update URL on the same domain ( our website )
const URLParse = (url, storeLocale) => {
    const result = getFullURL(url);
    const { hash, href, origin, pathname, search } = result;
    if (shouldIgnoreURL(result)) {
        return {
            isModified: false,
            href,
            pathname,
        };
    }
    const updatedPath = (0, exports.createNewURLPath)(pathname, storeLocale);
    return {
        isModified: true,
        href: `${origin}${updatedPath}${hash || ''}${search || ''}`,
        pathname: updatedPath,
    };
};
exports.URLParse = URLParse;
// Workaround for Akamai Cache and USER putting in MANUAL Url or Hitting Akamai Cache
// We check that they are currently setup to the correct `storeLocale` or we will redirect
const validateBrowserStoreLocale = (storeLocale, forceRefresh = false) => {
    const path = (0, exports.createNewBrowserPath)(storeLocale);
    const { href, origin } = window.location;
    // check if the `href` ( full URL ) is the same as path
    // 'https://www.saatchiart.com' ( remove/replace origin ) => '/en-fr/all?style=abstract' !== `/${storeLocale}/all?style=abstract`
    const redirectRequired = href.replace(origin, '') !== path || forceRefresh;
    if (redirectRequired) {
        const path = (0, exports.createNewBrowserPath)(storeLocale);
        // We need to handle HOMEPAGE => `en-us` which is blank =>  '' ( default to '/' )
        window.location.href = path || '';
    }
    return redirectRequired;
};
exports.validateBrowserStoreLocale = validateBrowserStoreLocale;
